import { api } from '@/services'
import {
  boardServiceTypeOptions,
  filterBoardByServiceType,
} from '@/util/boardServiceTypeFilter'

const state = {
  board: {
    OPEN: [],
    SCHEDULED: [],
    CANCELED: [],
    DONE: [],
  },
  boardFilters: {
    dayOfWeek: '',
    searchText: '',
    realEstateOperatorAppointments: false,
  },
  boardDensity: 'DEFAULT',
  boardDensityOptions: {
    DEFAULT: 'mdi-grid-large',
    COMPACT: 'mdi-grid',
    LIST: 'mdi-format-list-bulleted-type',
  },
  boardPendingActions: false,
  boardActiveLine: 'OPEN',
  boardLoading: false,
  boardServiceType: null,
  boardContractServiceTypes: [],
}

const getters = {
  board: (state) => state.board,
  boardFilters: (state) => state.boardFilters,
  boardDensity: (state) => state.boardDensity,
  boardDensityOptions: (state) => state.boardDensityOptions,
  boardPendingActions: (state) => state.boardPendingActions,
  boardActiveLine: (state) => state.boardActiveLine,
  boardLoading: (state) => state.boardLoading,
  boardServiceType: (state) => state.boardServiceType,
  filteredBoard: (state) => filterBoardByServiceType(state.board, state.boardServiceType),
  boardServiceTypeOptions: (state) =>
    boardServiceTypeOptions(state.boardContractServiceTypes, state.board, state.boardServiceType),
}

const actions = {
  async fetchBoard({ commit, dispatch, rootState }) {
    commit('setBoardLoading', true)

    const params = { ...rootState.filters.filters }

    try {
      const { data } = await api.get('/web/appointment/board', { params })
      commit('setBoard', data)
    } catch (error) {
      dispatch('showErrorMessage', error)
    } finally {
      commit('setBoardLoading', false)
    }
  },

  async fetchBoardContractServiceTypes({ commit, dispatch }) {
    try {
      const { data } = await api.get('/web/appointment/realEstateServiceTypes')
      commit('setBoardContractServiceTypes', data)
    } catch (error) {
      dispatch('showErrorMessage', error)
    }
  },

  handleBoardDensity({ commit, dispatch }, payload) {
    commit('setBoardDensity', payload)
    dispatch('fetchBoard')
  },
}

const mutations = {
  setBoard: (state, board) => {
    state.board = board
  },

  setBoardFilters: (state, boardFilters) => {
    state.boardFilters = boardFilters
  },

  setBoardDensity: (state, status) => {
    state.boardDensity = status
  },

  setBoardPendingActions: (state, status) => {
    state.boardPendingActions = status
  },

  setBoardActiveLine: (state, status) => {
    state.boardActiveLine = status === state.boardActiveLine ? 'NONE' : status
  },

  setBoardLoading: (state, status) => {
    state.boardLoading = status
  },

  setBoardServiceType: (state, serviceType) => {
    state.boardServiceType = serviceType
  },

  setBoardContractServiceTypes: (state, types) => {
    state.boardContractServiceTypes = types
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
